import React, { useState } from "react";
import { Dropdown, Button, Form, Row, Col, Container } from "react-bootstrap";
import DatePicker from "react-datepicker";
import RightSideDrawer from "./Drawer";
import { Urls } from "../utils/endPoints/apiUrls";
import { useEffect } from "react";
import { apiRequest } from "../utils/comman/apiRequest";

const FilterBar = ({ filters, setFilters }) => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [types, setTypeDropDown] = useState([]);
  const [materials, setMaterialDropDown] = useState([]);
  const [sizes, setProductSize] = useState([]);

  const fetchMaterialDropdown = async () => {
    const { data, status } = await apiRequest({
      method: "GET",
      endUrl: Urls?.materialDropDown,
    });
    if (status) {
      setMaterialDropDown(data?.rows);
    }
  };

  const fetchTypesDropdown = async () => {
    const { data, status } = await apiRequest({
      method: "GET",
      endUrl: Urls?.productTypes,
    });
    if (status) {
      setTypeDropDown(data?.rows);
    }
  };

  const fetchSizesDropdown = async () => {
    const { data, status } = await apiRequest({
      method: "GET",
      endUrl: Urls?.productSize,
    });
    if (status) {
      setProductSize(data?.rows);
    }
  };

  useEffect(() => {
    fetchTypesDropdown();
    fetchMaterialDropdown();
    fetchSizesDropdown();
  }, [filters]);

  useEffect(() => {
  if (filters.selectedMarketplaces.length === 0) {
    setFilters((prev) => ({
      ...prev,
      selectedMarketplaces: ["Amazon"],
    }));
  }
}, [filters.selectedMarketplaces]);


  const cities = [
    { label: "New Delhi", value: "110001" },
    { label: "Mumbai", value: "400001" },
    { label: "Bangalore", value: "500001" },
    { label: "Chennai", value: "600001" },
    { label: "Kolkata", value: "700001" },
    { label: "Gwalior", value: "474001" },
    { label: "Hyderabad", value: "560047" },
  ];

  const brands = [
    { label: "Wakefit", value: "Wakefit" },
    { label: "SleepyCat", value: "SleepyCat" },
    { label: "Kurlon", value: "Kurl-On" },
    { label: "Duroflex", value: "duroflex" },
    { label: "The Sleep Company", value: "The Sleep Company" },
    { label: "Sleepwell", value: "Sleepwell" },
    { label: "Sleep Head", value: "Sleephead" },
    { label: "Loom & Needles", value: "Loom & Needles" },
  ];

  const marketplaces = [
    { label: "Amazon", value: "Amazon" },
    { label: "Flipkart", value: "Flipkart" },
  ];

  // const availability = [
  //   { label: "In Stock", value: "InStock" },
  //   { label: "Out of Stock", value: "OutOfStock" },
  // ];

  //for multiselect feature enable this function and comment below one
  // const toggleSelection = (value, key) => {
  //   setFilters((prev) => ({
  //     ...prev,
  //     [key]: prev[key].includes(value)
  //       ? prev[key].filter((v) => v !== value)
  //       : [...prev[key], value],
  //   }));
  // };

  const toggleSelection = (value, key, isSingleSelect = false) => {
    setFilters((prev) => {
      const alreadySelected = prev[key].includes(value);

      if (isSingleSelect) {
        return {
          ...prev,
          [key]: alreadySelected ? [] : [value],
        };
      } else {
        return {
          ...prev,
          [key]: alreadySelected
            ? prev[key].filter((v) => v !== value)
            : [...prev[key], value],
        };
      }
    });
  };

  const [showDrawer, setShowDrawer] = useState(false);

  const getLabel = (arr, selected) =>
    arr.find((item) => item.value === selected)?.label || "Select";

  return (
    <>
      <Row className="align-items-center g-2">
        <Col xs={12} md={10}>
          <Row className="align-items-center g-0 filterrow">
            <Col xs={12} md={3}>
              <div className="d-flex align-items-center">
                <Form.Label className="mb-0 filterText me-2 ms-2">
                  Start Date:
                </Form.Label>
                <DatePicker
                  selected={filters.startDate}
                  onChange={(date) =>
                    setFilters((prev) => ({ ...prev, startDate: date }))
                  }
                  selectsStart
                  startDate={filters.startDate}
                  endDate={filters.endDate}
                  dateFormat="dd MMM yyyy"
                  className="form-control date-formcontrol"
                  placeholderText="Start Date"
                />
              </div>
            </Col>
            <Col xs={12} md={3}>
              <div className="d-flex align-items-center">
                <Form.Label className="mb-0 filterText me-2 ms-2">
                  End Date:
                </Form.Label>
                <DatePicker
                  selected={filters.endDate}
                  onChange={(date) =>
                    setFilters((prev) => ({ ...prev, endDate: date }))
                  }
                  selectsEnd
                  startDate={filters.startDate}
                  endDate={filters.endDate}
                  minDate={filters.startDate}
                  dateFormat="dd MMM yyyy"
                  className="form-control date-formcontrol"
                  placeholderText="End Date"
                />
              </div>
            </Col>

            <Col xs={12} md={2}>
              <Dropdown
                show={openDropdown === "material"}
                onToggle={(isOpen) =>
                  setOpenDropdown(isOpen ? "material" : null)
                }
              >
                <Dropdown.Toggle variant="outline-secondary dropbtn">
                  Material:{" "}
                  <span className="droptxt">
                    {filters.selectedMaterials[0] || "Select"}
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Form.Label className="px-3 filterText">
                    Select Material
                  </Form.Label>
                  {materials.map((mat) => (
                    <Form.Check
                      key={mat?.name}
                      type="checkbox"
                      label={mat?.name}
                      checked={filters.selectedMaterials.includes(mat.name)}
                      // onChange={() => toggleSelection(mat?.name, "selectedMaterials")}
                      onChange={() => {
                        toggleSelection(mat?.name, "selectedMaterials");
                        setOpenDropdown(null); // Close dropdown after selection
                      }}
                    />
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </Col>

            <Col xs={12} md={2}>
              <Dropdown
                show={openDropdown === "type"}
                onToggle={(isOpen) => setOpenDropdown(isOpen ? "type" : null)}
              >
                <Dropdown.Toggle variant="outline-secondary dropbtn">
                  Type:{" "}
                  <span className="droptxt">
                    {filters.selectedTypes[0] || "Select"}
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Form.Label className="px-3 filterText">
                    Select Type
                  </Form.Label>
                  {types.map((type) => (
                    <Form.Check
                      key={type?.name}
                      type="checkbox"
                      label={type?.name}
                      checked={filters.selectedTypes.includes(type?.name)}
                      // onChange={() => toggleSelection(type?.name, 'selectedTypes')}
                      onChange={() => {
                        toggleSelection(type?.name, "selectedTypes");
                        setOpenDropdown(null); // close after selection
                      }}
                    />
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </Col>

            <Col xs={12} md={2}>
              <Dropdown
                show={openDropdown === "size"}
                onToggle={(isOpen) => setOpenDropdown(isOpen ? "size" : null)}
              >
                <Dropdown.Toggle variant="outline-secondary dropbtn">
                  Size:{" "}
                  <span className="droptxt">
                    {filters.selectedSizes[0] || "Select"}
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Form.Label className="px-3 filterText">
                    Select Size
                  </Form.Label>
                  {sizes.map((size) => (
                    <Form.Check
                      key={size?.name}
                      type="checkbox"
                      label={size?.name}
                      checked={filters.selectedSizes.includes(size?.name)}
                      // onChange={() => toggleSelection(size?.name, 'selectedSizes')}
                      onChange={() => {
                        toggleSelection(size?.name, "selectedSizes");
                        setOpenDropdown(null); // close after selection
                      }}
                    />
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </Col>
          </Row>
        </Col>

        <Col xs={12} md={2}>
          <Button
            onClick={() => setShowDrawer(true)}
            variant="primary morefilterBtn"
          >
            More Filters
          </Button>
        </Col>
      </Row>

      {/* Right Side Drawer for more filters */}
      <RightSideDrawer
        show={showDrawer}
        title="More Filters"
        subtitle={"04 Applied"}
        onClose={() => setShowDrawer(false)}
      >
        <Container>
          <Row>
            <Col md={12}>
              <p className="head-text">By City</p>
            </Col>
            {cities.map((city) => (
              <Col md={6} key={city.value}>
                <Form.Check
                  type="checkbox"
                  label={city.label}
                  checked={filters.selectedCities.includes(city.value)}
                  onChange={() =>
                    toggleSelection(city.value, "selectedCities", true)
                  }
                />
              </Col>
            ))}

            <hr style={{ color: "#E4E8F1" }} />

            <Col md={12}>
              <p className="head-text">By Brands</p>
            </Col>
            {brands.map((brand) => (
              <Col md={6} key={brand.value}>
                <Form.Check
                  type="checkbox"
                  label={brand.label}
                  checked={filters.selectedBrands.includes(brand.value)}
                  onChange={() =>
                    toggleSelection(brand.value, "selectedBrands", true)
                  }
                />
              </Col>
            ))}

            <hr style={{ color: "#E4E8F1" }} />

            <Col md={12}>
              <p className="head-text">By Marketplace</p>
            </Col>
            {marketplaces.map((market) => (
              <Col md={6} key={market.value}>
                <Form.Check
                  type="checkbox"
                  label={market.label}
                  checked={filters.selectedMarketplaces.includes(market.value)}
                  onChange={() =>
                    toggleSelection(market.value, "selectedMarketplaces", true)
                  }
                />
              </Col>
            ))}

            {/* <hr style={{ color: "#E4E8F1" }} /> */}

            {/* <Col md={12}>
              <p className="head-text">Availability</p>
            </Col>
            {availability.map((option) => (
              <Col md={6} key={option.value}>
                <Form.Check
                  type="checkbox"
                  label={option.label}
                  checked={filters.selectedAvailability.includes(option.value)}
                  onChange={() => toggleSelection(option.value, "selectedAvailability",true)}
                />
              </Col>
            ))} */}
          </Row>
        </Container>
      </RightSideDrawer>
    </>
  );
};

export default FilterBar;
